'use client';

import { useState, useEffect } from 'react';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from '../../../components/ui/tabs';
import { ApplicationHeader } from '../../../components/application/header';
import { ApplicationDetailsCard } from '../../../components/application/application-details-card';
import { CompanyDetailsCard } from '../../../components/application/company-details-card';
import { AgentDetailsCard } from '../../../components/application/agent-details-card';
import { DocumentsSection } from '../../../components/application/documents-section';
import { DecisionMatrixCard } from '../../../components/application/decision-matrix-card';
import { DecisionGrid } from '../../../components/application/decision-grid';
import { NotesTab } from '../../../components/application/notes-tab';
import { HistoryTab } from '../../../components/application/history-tab';
import { AIGeneratedIndicator } from '../../../components/ui/ai-generated-indicator';
import { Card } from '../../../components/ui/card';
import { useSelector } from 'react-redux';
import fetchData from '../../../utils/fetchData';

// Static application data
const staticApplicationData = {
  id: 'cipilotiaiapp09100392',
  name: 'Rubber Mill, Inc.',
  submittedDate: 'Apr 12, 2025',
  updatedTime: '2 hours ago',
  priority: 'Medium'
};

export default function ApplicationDetailsPage() {
  const [isFullWidth, setIsFullWidth] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');

  const selectedApplicationData = useSelector(
    state => state.intakeData.selectedApplicationData
  );

  const [statusList, setStatusList] = useState([]);

  useEffect(() => {
    fetchData(
      `https://cipilot-lexai-api-318242574572.us-central1.run.app/insureai/ml/intake/applications/v2/application_status?application_id=${selectedApplicationData?.application_id}`,
      'GET'
    ).then(data => {
      setStatusList(data);
    });
  }, [selectedApplicationData]);

  return (
    <div className='min-h-screen bg-gray-50 flex flex-col'>
      {/* <ApplicationHeader /> */}

      {/* Main Content */}
      <div className='flex-1 flex'>
        {/* Application Content */}
        <div className='flex-1 overflow-auto'>
          <div className='p-6 max-w-[1600px] mx-auto'>
            <ApplicationDetailsCard
              isFullWidth={isFullWidth}
              setIsFullWidth={setIsFullWidth}
              selectedApplicationData={selectedApplicationData || {}}
            />

            {/* Main Content Tabs */}
            <Tabs
              defaultValue='overview'
              className='mb-6'
              onValueChange={setActiveTab}
              value={activeTab}
            >
              <TabsList className='bg-white rounded-lg shadow-md p-1 w-full justify-start'>
                <TabsTrigger
                  value='overview'
                  className='data-[state=active]:bg-[#FFF0ED] data-[state=active]:text-[#FF5533]'
                >
                  Overview
                </TabsTrigger>
                {/* <TabsTrigger
                  value='notes'
                  className='data-[state=active]:bg-[#FFF0ED] data-[state=active]:text-[#FF5533]'
                >
                  Notes
                </TabsTrigger>
                 <TabsTrigger
                  value='history'
                  className='data-[state=active]:bg-[#FFF0ED] data-[state=active]:text-[#FF5533]'
                >
                  History
                </TabsTrigger>
                <TabsTrigger
                  value='decision'
                  className='data-[state=active]:bg-[#FFF0ED] data-[state=active]:text-[#FF5533]'
                >
                  Decision Grid
                </TabsTrigger> */}
              </TabsList>

              {/* Overview Tab Content */}
              <TabsContent value='overview' className='mt-4 space-y-4'>
                <div className='grid grid-cols-3 gap-6'>
                  <CompanyDetailsCard
                    selectedApplicationData={selectedApplicationData || {}}
                    statusList={statusList}
                  />
                  <AgentDetailsCard
                    selectedApplicationData={selectedApplicationData || {}}
                  />
                </div>

                <DocumentsSection
                  selectedApplicationData={selectedApplicationData || {}}
                />
                <DecisionMatrixCard
                  selectedApplicationData={selectedApplicationData || {}}
                />
              </TabsContent>

              {/* Notes Tab Content */}
              <TabsContent value='notes' className='mt-4'>
                <NotesTab />
              </TabsContent>

              {/* History Tab Content */}
              <TabsContent value='history' className='mt-4'>
                <HistoryTab />
              </TabsContent>

              {/* Decision Grid Tab Content */}
              <TabsContent value='decision' className='mt-4'>
                <Card className='p-5 bg-white shadow-md'>
                  <h2 className='text-lg font-semibold mb-4'>
                    Application Decision Grid
                  </h2>
                  <DecisionGrid
                    selectedApplicationData={selectedApplicationData}
                  />
                </Card>
              </TabsContent>
            </Tabs>
          </div>

          {/* AI Generated Indicator */}
          <AIGeneratedIndicator />
        </div>
      </div>
    </div>
  );
}
